export class TerraPaymentConfigMapperRequest {
    paymentConfigId: string;
    moduleConfigId: string;
    isDefault: boolean;

    public constructor(paymentConfigId: string, moduleConfigId: string, isDefault: boolean = false){
        this.paymentConfigId = paymentConfigId;
        this.moduleConfigId = moduleConfigId;
        this.isDefault = isDefault;
    }
}